import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeLegalTextSkeleton } from './TypeLegalText';

export interface TypeLeadFormFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    formType: EntryFieldTypes.Symbol<'IN_PAGE' | 'MODAL'>;
    name: EntryFieldTypes.Symbol;
    description?: EntryFieldTypes.RichText;
    fields?: EntryFieldTypes.Array<
        EntryFieldTypes.Symbol<
            | 'ADDRESS'
            | 'COMMENT'
            | 'COMPANY_CODE_NAME'
            | 'EMAIL_ADDRESS'
            | 'NAME_SURNAME'
            | 'PHONE_NUMBER'
            | 'PHONE_NUMBER_NO_PREFILL'
            | 'PRODUCT_TYPE'
        >
    >;
    commentHint?: EntryFieldTypes.Text;
    productTypeValue?: EntryFieldTypes.Symbol<
        | '5G'
        | 'Fix Voice'
        | 'Fix internet other services'
        | 'Fix internet'
        | 'For new companies'
        | 'Get an offer (mail)'
        | 'IT'
        | 'MBB'
        | 'MHS'
        | 'Microsoft 365'
        | 'RRT'
        | 'SMS wholesale'
        | 'Shop'
        | 'Support, help'
        | 'eSim'
    >;
    legalText?: EntryFieldTypes.EntryLink<TypeLegalTextSkeleton>;
    submitButtonLabel: EntryFieldTypes.Symbol;
    successMessage: EntryFieldTypes.RichText;
}

export type TypeLeadFormSkeleton = EntrySkeletonType<TypeLeadFormFields, 'leadForm'>;
export type TypeLeadForm<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeLeadFormSkeleton,
    Modifiers,
    Locales
>;

export function isTypeLeadForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeLeadForm<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'leadForm';
}
